import type { IconNode } from '../types';

/**
 * @name mailbox-flag
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjAgNS41QTQgNCAwIDAgMSAyMiA5djhhMiAyIDAgMCAxLTIgMkg0YTIgMiAwIDAgMS0yLTJWOWE0IDQgMCAwIDEgOCAwdjhhMiAyIDAgMCAxLTIgMiIgLz4KICA8cGF0aCBkPSJNNiA1aDQiIC8+CiAgPHBhdGggZD0iTTE0IDlWNWgydjFoLTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/mailbox-flag
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const mailboxFlag: IconNode = [
  [
    'path',
    {
      d: 'M20 5.5A4 4 0 0 1 22 9v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a4 4 0 0 1 8 0v8a2 2 0 0 1-2 2',
      key: '1r8uwb',
    },
  ],
  ['path', { d: 'M6 5h4', key: 'qhk020' }],
  ['path', { d: 'M14 9V5h2v1h-2', key: '142l1k' }],
];

export default mailboxFlag;
